module.exports = __webpack_public_path__ + "fonts/color.c7a33805ffda0d32bd2a9904c8b02750.png?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/color.png
// module id = 908
// module chunks = 6